export default {
  toolbarToggle: '49px',
  cart: '282px',
  productGap: '16px',
  categoryTabToggle: '46px',
  topbar: {
    mobile: '48px',
    tablet: '60px',
  },
  padding: {
    x: '30px',
    y: '16px',
  },
};



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/size.js